//SIDEBAR SLIDER
export const OPEN_SLIDER = "OPEN_SLIDER";
export const CLOSE_SLIDER = "CLOSE_SLIDER";
export const SELECTED_MENU_ITEM = "SELECTED_MENU_ITEM";

//HEADER BUTTON
export const SET_HEADER_BUTTON_PARAMS = "SET_HEADER_BUTTON_PARAMS";
export const SET_HEADER_TEXT = "SET_HEADER_TEXT";
export const SET_HEADER_ADVANCED_SEARCH_PARAMS = "SET_HEADER_ADVANCED_SEARCH_PARAMS";

//COMMON FORM ACTIONS
export const IS_SUBMITTING = "IS_SUBMITTING";
export const SUBMIT_SUCCESS = "SUBMIT_SUCCESS";
export const SUBMIT_ERROR = "SUBMIT_ERROR";
export const RESET_FORM_STATUS = "RESET_FORM_STATUS";
export const IS_UPDATING = "IS_UPDATING";
export const UPDATE_SUCCESS = "UPDATE_SUCCESS";
export const UPDATE_ERROR = "UPDATE_ERROR";

//EDIT FORM ACTIONS
export const SET_EDIT = "SET_EDIT";
export const RESET_EDIT = "RESET_EDIT";

//SETTINGS MODULE
export const SETTINGS_IS_LOADING = "SETTINGS_IS_LOADING";
export const SETTINGS_LOAD_SUCCESS = "SETTINGS_LOAD_SUCCESS";
export const SETTINGS_LOAD_ERROR = "SETTINGS_LOAD_ERROR";

// ANNOUNCEMENTS MODULE
export const ANNOUNCEMENTS_IS_LOADING = "ANNOUNCEMENTS_IS_LOADING";
export const ANNOUNCEMENTS_LOAD_SUCCESS = "ANNOUNCEMENTS_LOAD_SUCCESS";
export const ANNOUNCEMENTS_LOAD_ERROR = "ANNOUNCEMENTS_LOAD_ERROR";

export const ANNOUNCEMENTS_DATA_LOADING = 'ANNOUNCEMENTS_DATA_LOADING';
export const ANNOUNCEMENTS_DATA_SUCCESS = 'ANNOUNCEMENTS_DATA_SUCCESS';
export const ANNOUNCEMENTS_DATA_ERROR = 'ANNOUNCEMENTS_DATA_ERROR';

// STATISTICS - DASHBOARD MODULE
export const STATISTICS_IS_LOADING = "STATISTICS_IS_LOADING";
export const STATISTICS_LOAD_SUCCESS = "STATISTICS_LOAD_SUCCESS";
export const STATISTICS_LOAD_ERROR = "STATISTICS_LOAD_ERROR";

// STATISTICS - PARTICPANTS MODULE
export const STATISTICS_PARTICIPANT_IS_LOADING = "STATISTICS_PARTICIPANT_IS_LOADING";
export const STATISTICS_PARTICIPANT_LOAD_SUCCESS = "STATISTICS_PARTICIPANT_LOAD_SUCCESS";
export const STATISTICS_PARTICIPANT_LOAD_ERROR = "STATISTICS_PARTICIPANT_LOAD_ERROR";

// LEADERSHIP BOARD - DASHBOARD MODULE
export const LEADERSHIP_BOARD_IS_LOADING = "LEADERSHIP_BOARD_IS_LOADING";
export const LEADERSHIP_BOARD_LOAD_SUCCESS = "LEADERSHIP_BOARD_LOAD_SUCCESS";
export const LEADERSHIP_BOARD_LOAD_ERROR = "LEADERSHIP_BOARD_LOAD_ERROR";

// REPORTS MODULE
export const REPORTS_IS_LOADING = "REPORTS_IS_LOADING";
export const REPORTS_LOAD_SUCCESS = "REPORTS_LOAD_SUCCESS";
export const REPORTS_LOAD_ERROR = "REPORTS_LOAD_ERROR";

//LIVE COURSES MODULE
export const LIVE_COURSES_IS_LOADING = "LIVE_COURSES_IS_LOADING";
export const LIVE_COURSES_LOAD_SUCCESS = "LIVE_COURSES_LOAD_SUCCESS";
export const LIVE_COURSES_LOAD_ERROR = "LIVE_COURSES_LOAD_ERROR";

//ACCESS_TOKEN LIVE SESSIONS
export const SET_ACCESS_TOKEN = "SET_ACCESS_TOKEN";
export const RESET_ACCESS_TOKEN = "RESET_ACCESS_TOKEN";

//SEARCH FUNCTION AUTOCOMPLETE
export const SEARCH_AUTOCOMPLETE_LIST_LOADING = 'SEARCH_AUTOCOMPLETE_LIST_LOADING';
export const SEARCH_QUERY_LOADING = "SEARCH_QUERY_LOADING";
export const SEARCH_COMPONENT_RESET = "SEARCH_COMPONENT_RESET";
export const SEARCH_FINAL_QUERY = "SEARCH_FINAL_QUERY";
export const SET_AUTOCOMPLETE_VISIBILITY = "SET_AUTOCOMPLETE_VISIBILITY";

//ADVANCED SEARCH
export const SET_ADVANCED_SEARCH = 'SET_ADVANCED_SEARCH';
export const RESET_ADVANCED_SEARCH = 'RESET_ADVANCED_SEARCH';

//CALENDAR MONTH
export const MONTH_IS_LOADING = "MONTH_IS_LOADING";
export const MONTH_LOAD_SUCCESS = "MONTH_LOAD_SUCCESS";
export const MONTH_LOAD_ERROR = "MONTH_LOAD_ERROR";
export const SET_HOLIDAY_TYPE = "SET_HOLIDAY_TYPE";

//LOAD SUBJECTS
export const SUBJECTS_IS_LOADING = "SUBJECTS_IS_LOADING";
export const SUBJECTS_LOAD_SUCCESS = "SUBJECTS_LOAD_SUCCESS";
export const SUBJECTS_LOAD_ERROR = "SUBJECTS_LOAD_ERROR";

//LOAD SESSION
export const SESSION_TIMINGS_IS_LOADING = "SESSION_TIMINGS_IS_LOADING";
export const SESSION_TIMINGS_LOAD_SUCCESS = "SESSION_TIMINGS_LOAD_SUCCESS";
export const SESSION_TIMINGS_LOAD_ERROR = "SESSION_TIMINGS_LOAD_ERROR";

//LOAD CLASSES
export const CLASSES_IS_LOADING = "CLASSES_IS_LOADING";
export const CLASSES_LOAD_SUCCESS = "CLASSES_LOAD_SUCCESS";
export const CLASSES_LOAD_ERROR = "CLASSES_LOAD_ERROR";

//LOAD DEGREE
export const DEGREE_IS_LOADING = "DEGREE_IS_LOADING";
export const DEGREE_LOAD_SUCCESS = "DEGREE_LOAD_SUCCESS";
export const DEGREE_LOAD_ERROR = "DEGREE_LOAD_ERROR";

//LOAD SPECIFICATION
export const SPECIFICATION_IS_LOADING = "SPECIFICATION_IS_LOADING";
export const SPECIFICATION_LOAD_SUCCESS = "SPECIFICATION_LOAD_SUCCESS";
export const SPECIFICATION_LOAD_ERROR = "SPECIFICATION_LOAD_ERROR";

//LOAD EXAM SPECIFICATION
export const EXAM_SPECIFICATION_IS_LOADING = "EXAM_SPECIFICATION_IS_LOADING";
export const EXAM_SPECIFICATION_LOAD_SUCCESS = "EXAM_SPECIFICATION_LOAD_SUCCESS";
export const EXAM_SPECIFICATION_LOAD_ERROR = "EXAM_SPECIFICATION_LOAD_ERROR";

//LOAD GET EXAM
export const GET_EXAM_IS_LOADING = "GET_EXAM_IS_LOADING";
export const GET_EXAM_LOAD_SUCCESS = "GET_EXAM_LOAD_SUCCESS";
export const GET_EXAM_LOAD_ERROR = "GET_EXAM_LOAD_ERROR";

//TUTORS MODULE
export const TUTORS_IS_LOADING = "TUTORS_IS_LOADING";
export const TUTORS_LOAD_SUCCESS = "TUTORS_LOAD_SUCCESS";
export const TUTORS_LOAD_ERROR = "TUTORS_LOAD_ERROR";

//STUDENTS MODULE
export const STUDENTS_IS_LOADING = "STUDENTS_IS_LOADING";
export const STUDENTS_LOAD_SUCCESS = "STUDENTS_LOAD_SUCCESS";
export const STUDENTS_LOAD_ERROR = "STUDENTS_LOAD_ERROR";

//ADMIN APPROVAL
export const APPROVAL_BEGIN = "APPROVAL_BEGIN";
export const APPROVAL_SUCCESS = "APPROVAL_SUCCESS";
export const APPROVAL_ERROR = "APPROVAL_ERROR";
export const APPROVAL_RESET = "APPROVAL_RESET";

// Dashboard Statistics
export const DASHBOARD_BEGIN= "DASHBOARD_BEGIN";
export const DASHBOARD_SUCCESS = "DASHBOARD_SUCCESS";
export const DASHBOARD_ERROR = "DASHBOARD_ERROR";

//STUDENT LIST REPORTS MODULE
export const REPORTS_STUDENT_LIST_IS_LOADING = "REPORTS_STUDENT_LIST_IS_LOADING";
export const REPORTS_STUDENT_LIST_LOAD_SUCCESS = "REPORTS_STUDENT_LIST_LOAD_SUCCESS";
export const REPORTS_STUDENT_LIST_LOAD_ERROR = "REPORTS_STUDENT_LIST_LOAD_ERROR";


//Tutor LIST REPORTS MODULE
export const REPORTS_TUTOR_LIST_IS_LOADING = "REPORTS_TUTOR_LIST_IS_LOADING";
export const REPORTS_TUTOR_LIST_LOAD_SUCCESS = "REPORTS_TUTOR_LIST_LOAD_SUCCESS";
export const REPORTS_TUTOR_LIST_LOAD_ERROR = "REPORTS_TUTOR_LIST_LOAD_ERROR";


//STUDENT STATISICS REPORTS MODULE
export const REPORTS_STUDENT_STATISTICS_IS_LOADING = "REPORTS_STUDENT_STATISTICS_IS_LOADING";
export const REPORTS_STUDENT_STATISTICS_LOAD_SUCCESS = "REPORTS_STUDENT_STATISTICS_LOAD_SUCCESS";
export const REPORTS_STUDENT_STATISTICS_LOAD_ERROR = "REPORTS_STUDENT_STATISTICS_LOAD_ERROR";


//STUDENT Profile REPORTS MODULE
export const REPORTS_STUDENT_EXAM_SCHEDULE_IS_LOADING = "REPORTS_STUDENT_EXAM_SCHEDULE_IS_LOADING";
export const REPORTS_STUDENT_EXAM_SCHEDULE_LOAD_SUCCESS = "REPORTS_STUDENT_EXAM_SCHEDULE_LOAD_SUCCESS";
export const REPORTS_STUDENT_EXAM_SCHEDULE_LOAD_ERROR = "REPORTS_STUDENT_EXAM_SCHEDULE_LOAD_ERROR";


//Student Exam Schedule  Stats MODULE
export const REPORTS_STUDENT_EXAM_SCHEDULE_STATS_IS_LOADING = "REPORTS_STUDENT_EXAM_SCHEDULE_STATS_IS_LOADING";
export const REPORTS_STUDENT_EXAM_SCHEDULE_STATS_LOAD_SUCCESS = "REPORTS_STUDENT_EXAM_SCHEDULE_STATS_LOAD_SUCCESS";
export const REPORTS_STUDENT_EXAM_SCHEDULE_STATS_LOAD_ERROR = "REPORTS_STUDENT_EXAM_SCHEDULE_STATS_LOAD_ERROR";


//TUTOR STATISICS REPORTS MODULE
export const REPORTS_TUTOR_STATISTICS_IS_LOADING = "REPORTS_TUTOR_STATISTICS_IS_LOADING";
export const REPORTS_TUTOR_STATISTICS_LOAD_SUCCESS = "REPORTS_TUTOR_STATISTICS_LOAD_SUCCESS";
export const REPORTS_TUTOR_STATISTICS_LOAD_ERROR = "REPORTS_TUTOR_STATISTICS_LOAD_ERROR";


//TUTOR Exam Schedule  REPORTS MODULE
export const REPORTS_TUTOR_EXAM_SCHEDULE_IS_LOADING = "REPORTS_TUTOR_EXAM_SCHEDULE_IS_LOADING";
export const REPORTS_TUTOR_EXAM_SCHEDULE_LOAD_SUCCESS = "REPORTS_TUTOR_EXAM_SCHEDULE_LOAD_SUCCESS";
export const REPORTS_TUTOR_EXAM_SCHEDULE_LOAD_ERROR = "REPORTS_TUTOR_EXAM_SCHEDULE_LOAD_ERROR";

//TUTOR Exam Schedule Stats MODULE
export const REPORTS_TUTOR_EXAM_SCHEDULE_STATS_IS_LOADING = "REPORTS_TUTOR_EXAM_SCHEDULE_STATS_IS_LOADING";
export const REPORTS_TUTOR_EXAM_SCHEDULE_STATS_LOAD_SUCCESS = "REPORTS_TUTOR_EXAM_SCHEDULE_STATS_LOAD_SUCCESS";
export const REPORTS_TUTOR_EXAM_SCHEDULE_STATS_LOAD_ERROR = "REPORTS_TUTOR_EXAM_SCHEDULE_STATS_LOAD_ERROR";



//LOAD SCHEDULE
export const SCHEDULE_IS_LOADING = "SCHEDULE_IS_LOADING";
export const SCHEDULE_LOAD_SUCCESS = "SCHEDULE_LOAD_SUCCESS";
export const SCHEDULE_LOAD_ERROR = "SCHEDULE_LOAD_ERROR";
export const RESET_SCHEDULE_DATA = "RESET_SCHEDULE_DATA"



//LOAD Attendance
export const ATTENDANCE_IS_LOADING = "ATTENDANCE_IS_LOADING";
export const ATTENDANCE_LOAD_SUCCESS = "ATTENDANCE_LOAD_SUCCESS";
export const ATTENDANCE_LOAD_ERROR = "ATTENDANCE_LOAD_ERROR";

//LOAD All Attendance
export const ATTENDANCE_ALL_IS_LOADING = "ATTENDANCE_ALL_IS_LOADING";
export const ATTENDANCE_ALL_LOAD_SUCCESS = "ATTENDANCE_ALL_LOAD_SUCCESS";
export const ATTENDANCE_ALL_LOAD_ERROR = "ATTENDANCE_ALL_LOAD_ERROR";


//LOAD Attendance Data
export const ATTENDANCE_DATA_IS_LOADING = "ATTENDANCE_DATA_IS_LOADING";
export const ATTENDANCE_DATA_LOAD_SUCCESS = "ATTENDANCE_DATA_LOAD_SUCCESS";
export const ATTENDANCE_DATA_LOAD_ERROR = "ATTENDANCE_DATA_LOAD_ERROR";


//LOAD Attendance
export const ATTENDANCE_REPORT_IS_LOADING = "ATTENDANCE_REPORT_IS_LOADING";
export const ATTENDANCE_REPORT_LOAD_SUCCESS = "ATTENDANCE_REPORT_LOAD_SUCCESS";
export const ATTENDANCE_REPORT_LOAD_ERROR = "ATTENDANCE_REPORT_LOAD_ERROR";
